import { button, sectionInnerBlock } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { ColumnTextGrid } from '@/components/ui/data-display/column-text-grid/ColumnTextGrid';
import { DetailInnerSection } from '@/components/ui/layouts/sections/DetailInnerSection';
import { Instances } from '../Instances';

export const ColumnsTextBlock = ({ data }) => {
	const noTitleSection =
		data?.fields?.title?.length === 0 || data?.fields?.title?.length === null;

	const ctaSlug = data?.fields?.cta_slug;
	const ctaText = data?.fields?.cta_text;

	const renderAnchor =
		ctaText && ctaSlug ? (
			<Link className={button()} href={data?.fields?.cta_slug}>
				{data?.fields?.cta_text}
			</Link>
		) : null;

	return (
		<DetailInnerSection
			anchorSlot={renderAnchor}
			className={sectionInnerBlock().root}
			heading={{
				title: data?.fields?.title || null,
				intro: data?.fields?.intro || null,
			}}
			isRelation={!data?.meta?.has_relations}
		>
			<ColumnTextGrid>
				<Instances
					instances={data?.relations?.TextColumns}
					isRelation={data?.meta?.has_relations}
					hasParentTitle={!noTitleSection}
				/>
			</ColumnTextGrid>
		</DetailInnerSection>
	);
};
